import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'ui-carousel',
  template: `<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" [ngStyle]="{width: width}">
  <ol class="carousel-indicators">
      <li data-target="#carouselExampleIndicators" attr.data-slide-to="{{i}}" *ngFor="let item of items; let i=index;"
          [ngClass]="{'active':i == activeIndex}" (click)="goTo(i)">
      </li>
  </ol>
  <div class="carousel-inner">
    <div class="carousel-item" *ngFor="let item of items; let i=index;" [ngClass]="{'active':i == activeIndex}">
      <img src="{{item.src}}" alt="{{item.alt}}">
      <div class="carousel-caption d-none d-md-block">
        <h5>{{item.alt}}</h5>
        <p>{{item.alt}}</p>
      </div>
    </div>
  </div>
  <a class="carousel-control-prev" (click)="prev()" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" (click)="next()" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
`,
  styles: [``]
})
export class CarouselComponent implements OnInit {

  @Input() items: { src: string, alt: string }[] = [];
  @Output() afterNext = new EventEmitter();
  @Output() afterPrev = new EventEmitter();
  activeIndex: number;
  count: number;
  width = '600px';

  constructor() {
  }

  ngOnInit() {
    this.activeIndex = 0;
    this.count = this.items.length;
  }

  next() {
    (this.activeIndex < this.count - 1) ? this.activeIndex++ : this.activeIndex = 0;
    this.afterNext.emit({
      index: this.activeIndex,
      item: this.items[this.activeIndex]
    });
  }

  prev() {
    (this.activeIndex >= 1) ? this.activeIndex-- : this.activeIndex = this.count - 1;
    this.afterPrev.emit({
      index: this.activeIndex,
      item: this.items[this.activeIndex]
    });
  }

  goTo(i: number) {
    this.activeIndex = i;
  }
}
